module.exports = __webpack_public_path__ + "img/josla-en.79486346.png";